import { render } from "./CartBadge.vue?vue&type=template&id=5d51cfe9&scoped=true"
import script from "./CartBadge.vue?vue&type=script&lang=js"
export * from "./CartBadge.vue?vue&type=script&lang=js"

import "./CartBadge.vue?vue&type=style&index=0&id=5d51cfe9&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d51cfe9"]])

export default __exports__